<template>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32"><path d="M28.83 14.812L17.188 3.169a1.717 1.717 0 00-2.428 0l-2.418 2.418 3.067 3.067a2.039 2.039 0 012.583 2.6l2.956 2.956a2.043 2.043 0 11-1.224 1.152l-2.757-2.757v7.255a2.044 2.044 0 11-1.68-.06v-7.322a2.043 2.043 0 01-1.11-2.68l-3.023-3.023-7.983 7.983a1.718 1.718 0 000 2.43L14.813 28.83c.67.67 1.757.67 2.429 0L28.83 17.242a1.72 1.72 0 000-2.43"/></svg>
</template>

<script>
export default {
  name: 'brandGitFilled'
}
</script>
